import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight, Home } from 'lucide-react';

const MerciContactPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E9DFCF' }} data-testid="merci-contact-page">
      <Header />

      <main className="py-16 md:py-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-8">
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#1C2E4A' }}
            >
              <CheckCircle className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Title */}
          <h1
            className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 mb-4"
            style={{ letterSpacing: '-0.04em' }}
          >
            Message envoyé !
          </h1>

          {/* Description */}
          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            Merci pour votre message. Notre équipe vous répondra sous 24 à 48 heures ouvrées.
          </p>

          {/* Info Card */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-200 mb-8">
            <h2 className="font-semibold text-gray-900 mb-4">En attendant notre réponse</h2>
            <ul className="text-left space-y-3 text-gray-600">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span>Votre demande a bien été enregistrée</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span>Un email de confirmation vous a été envoyé</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span>Nous analyserons votre besoin pour vous proposer la meilleure solution</span>
              </li>
            </ul>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button
                className="text-white rounded-full px-8 py-3 transition-all hover:-translate-y-0.5"
                style={{ backgroundColor: '#1C2E4A' }}
              >
                <Home className="w-5 h-5 mr-2" />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/#diagnostic">
              <Button
                variant="outline"
                className="rounded-full px-8 py-3 transition-all hover:-translate-y-0.5"
              >
                Faire le diagnostic gratuit
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MerciContactPage;
